import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppService } from '../../../../../../core/services/app.service';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-send-email',
  templateUrl: './send-email.component.html',
  styleUrls: ['./send-email.component.css']
})
export class SendEmailOfaComponent implements OnInit {
  @Input() agent;
  emailContent: any;
  listTypeCourrier: any = [];
  response: any;
  id_type_courrier: any;
  reference: string;
  editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: '245px',
      minHeight: '0',
      maxHeight: '245px',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      fonts: [
        {class: 'arial', name: 'Arial'},
        {class: 'times-new-roman', name: 'Times New Roman'},
        {class: 'calibri', name: 'Calibri'},
        {class: 'comic-sans-ms', name: 'Comic Sans MS'}
      ],
      customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ]
};
  constructor(private activeModal: NgbActiveModal, private loadingBar: LoadingBarService,
  private _service: AppService, private storage: LocalStorageService, private toastrService: ToastrService) { }

  ngOnInit() {
    this.getAllTypeCourrier();
  }

  closeModal() {
    this.activeModal.close();
  }

  // Get all typeCourrier
  getAllTypeCourrier() {
    this.loadingBar.start();
      this._service.getData('campagne/type_courriers/all').subscribe((data: {}) => {
      this.loadingBar.stop();
      this.response = data;
      this.listTypeCourrier = this.response.data;
    });
  }

  sendEmail() {
    this.loadingBar.start();
    const data = {
      'campagne_ofa_id': this.storage.retrieve('idCampagneOfaSelected'),
      'agent_id': this.agent.id,
      'corps': this.emailContent,
      'type_courrier_id': this.id_type_courrier,
      'reference' : this.reference
    }
      this._service.postData('campagne/ofa/send_email_decision_final', data).subscribe((data: {}) => {
      this.loadingBar.stop();
        this.response = data;
        if (!this.response.error) {
          this.toastrService.success(this.response.message);
          this.activeModal.close();
        } else {
          this.toastrService.error(this.response.message);
        }
    });
  }

  onSelectTypeCourrier(data) {
    this.id_type_courrier = data;
  }

}
